export default __webpack_public_path__ + "static/media/blog04012020thumbnail.3975677c.jpeg";